module.exports = __webpack_public_path__ + "img/delivery.37ce489e.png";